/**
 * Converts an ISO date string (e.g. "2025-06-24") to MM/DD/YYYY format (e.g. "06/24/2025").
 * Returns the raw input if parsing fails or input is empty/invalid.
 */
export function formatBillDate(isoDate: string): string {
  if (!isoDate || typeof isoDate !== 'string') return isoDate ?? '';
  try {
    const d = new Date(isoDate + 'T00:00:00');
    if (isNaN(d.getTime())) return isoDate;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  } catch {
    return isoDate;
  }
}

/**
 * Formats a billing period range from two ISO date strings.
 * Uses consistent en-dash separator and handles missing dates.
 */
export function formatBillPeriod(start?: string, end?: string, fallback = 'No dates'): string {
  const s = start ? formatBillDate(start) : null;
  const e = end ? formatBillDate(end) : null;
  if (!s && !e) return fallback;
  return `${s || '?'} – ${e || '?'}`;
}
